import { AppState } from '../../model';

export const getUserNote = (state: AppState) => state.confirmDialog.note;

export const getUserResponseStatus = (state: AppState) =>
  state.confirmDialog.itineraryStatus;
